import React from 'react';
import { usedBy, plural } from '../../../models/LibraryModel';
import { formatTimestamp } from '../../../shared/datetime/timestamps';
import { showFullTextIfTruncated } from '../../../utils/truncationTooltip';
import LibraryStatusChip from './LibraryStatusChip';
import LibraryDocumentMenu, { ArchivedTip } from './LibraryDocumentMenu';

function usedByCell(doc) {
  const n = usedBy(doc);
  return n ? `${n} ${plural(n, 'scenario', 'scenarios')}` : 'Not in use';
}

// The archived tooltip sits in the menu cell, so the row keeps only cells, and
// is positioned against the row, so it centres on it.
function LibraryRow({ doc, actions }) {
  return (
    <div className={`library-row${doc.archived ? ' is-archived' : ''}`} role="row">
      <div data-doc-focus={doc.id} tabIndex={-1} role="cell" className="library-cell library-cell--strong" onMouseEnter={showFullTextIfTruncated}>{doc.name}</div>
      <div role="cell" className="library-cell" onMouseEnter={showFullTextIfTruncated}>{doc.fileName}</div>
      <div role="cell"><LibraryStatusChip doc={doc} /></div>
      <div role="cell" className="library-cell" title={formatTimestamp(doc.uploadedAt, 'long')}>{formatTimestamp(doc.uploadedAt, 'short')}</div>
      <div role="cell" className="library-cell">{usedByCell(doc)}</div>
      <div role="cell" className="library-cell--menu">
        <LibraryDocumentMenu doc={doc} actions={actions} />
        <ArchivedTip doc={doc} />
      </div>
    </div>
  );
}

/**
 * The list view: a panel holding a table. The head and the rows share one
 * column template, so every header sits over its own column. A row is a band
 * across the table — it takes the hover wash and the hairline, never a radius.
 */
function LibraryList({ documents, label, actions }) {
  return (
    <div className="library-panel">
      <div className="library-list" role="table" aria-label={label}>
        <div className="library-list-head" role="row">
          <div role="columnheader">Name</div>
          <div role="columnheader">File</div>
          <div role="columnheader">Status</div>
          <div role="columnheader">Uploaded</div>
          <div role="columnheader">Used by</div>
          <div role="columnheader"><span className="library-sr-only">Actions</span></div>
        </div>
        {documents.map((doc) => <LibraryRow key={doc.id} doc={doc} actions={actions} />)}
      </div>
    </div>
  );
}

export default LibraryList;
